import * as angular from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import nvSharedModelsModule from '../nv.shared.models.module';

angular
  .module(nvSharedModelsModule)

  .factory('School', function(NvBaseModel, PublicConfig, ImSchool: ImSchool, enqueuedPatchFieldsMixin) {
    let School = NvBaseModel(
      '/v1/schools/:id/',
      { id: '@_id' },
      {
        getGafeUsers: {
          method: 'GET',
          isArray: true,
          url: PublicConfig.NV_API_ORIGIN + '/v1/schools/:id/gafeUsers',
        },
        getGafeOrgUnits: {
          method: 'GET',
          url: PublicConfig.NV_API_ORIGIN + '/v1/schools/:id/gafeOrgUnits',
        },
      },
    );

    School.extend({
      // Let ImSchool know that it should never memoize these schools, since they are mutable
      _mutable: true,
    });

    School.placePublicImSchoolStaticMethodsOnPrototype = function() {
      // Object.getPrototypeOf needed now that ImSchool is a class (JE)
      const methodNames = Object.getOwnPropertyNames(Object.getPrototypeOf(ImSchool));
      const ImSchoolStaticMethods = _.difference(methodNames, ['constructor', 'length', 'name', 'prototype']);
      // remove ImSchool private methods
      _.remove(ImSchoolStaticMethods, staticMethod => {
        return staticMethod.indexOf('_') === 0;
      });

      _.forEach(ImSchoolStaticMethods, staticMethod => {
        if (School.prototype[staticMethod]) {
          throw new Error(`ImSchool.${staticMethod} static method already exists in School.prototype`);
        }

        School.prototype[staticMethod] = function(...params) {
          params.unshift(this);
          return ImSchool[staticMethod].apply(null, params);
        };
      });
    };

    // School.placePublicImSchoolStaticMethodsOnPrototype();

    return enqueuedPatchFieldsMixin(School); // attaches specific methods to model before return
  });
